// extracted by mini-css-extract-plugin
export default {"link":"counter_author_link__Vr8NX","loading":"counter_author_loading__qspa2"};